(function () {
  var TAGS = {
    "/products/aviri-mystery-gift-box-5-piece-surprise-set": { label: "Petal Bag", icon: "❀", cls: "petal" },
    "/products/aviri-mystery-gift-box-7-piece-surprise-set": { label: "Royal Bag", icon: "♛", cls: "royal" },
    "/products/aviri-mystery-gift-box-10-piece-surprise-set": { label: "Luxe Bag", icon: "♦", cls: "luxe" }
  };

  function apply() {
    document.querySelectorAll(".card-wrapper").forEach(function (card) {
      var link = card.querySelector("a[href]");
      if (!link) return;
      var path;
      try {
        path = new URL(link.getAttribute("href"), location.origin).pathname;
      } catch (e) {
        return;
      }
      var tag = TAGS[path];
      if (!tag) return;
      var media = card.querySelector(".card__media");
      if (!media || media.querySelector(".aviri-display-tag")) return;
      var wrap = document.createElement("div");
      wrap.className = "aviri-display-tag aviri-display-tag--" + tag.cls;
      var icon = document.createElement("span");
      icon.className = "aviri-tag-icon";
      icon.textContent = tag.icon;
      var pill = document.createElement("span");
      pill.className = "aviri-tag-pill";
      pill.textContent = tag.label;
      wrap.appendChild(icon);
      wrap.appendChild(pill);
      media.insertBefore(wrap, media.firstChild);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apply);
  } else {
    apply();
  }
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();
